import queryString from "query-string";

import type { QueryVariables } from "../types/app.types";

export default function getQueryVariable(): QueryVariables {
  // query-string returns a loosely typed ParsedQuery; cast at the boundary.
  const result = queryString.parse(window.location.search.substring(1), {
    arrayFormat: "comma",
    parseNumbers: true,
  }) as unknown as QueryVariables;
  if (result.sliderValues !== undefined) result.sliderValues.splice(8, 0, 99);

  return result;
}
